import Vue from 'vue'
import Vuex from 'vuex'
import { helpDocUrl } from '@/api/index'

import { hasCrmEquity, delveList } from '@/views/clue/api/newClueApi'

import { getToken } from '@/base/cookie'
import { Message } from 't-tyui'
import { queryUserCallClient, callOut } from '@/views/call/api'

import stepStore from './stepStore'
import lastdrawer from './lastdrawerStore.js'
import tokenList from './cancelAxios.js'
import buildPlatformStepStore from './buildPlatformStepStore'
import keepAliveStore from './keepAliveStore'
import industryChainStore from './industryChainStore'
import advancedSearch from './advancedSearch'
import asyncRoute from '@/store/asyncRoute'
import someInterest from './someInterest.js'
const setIntervalImmediately = (func, interval) => {
  func()
  return setInterval(func, interval)
}

Vue.use(Vuex)
let interval = null

const user = {
  state: {
    frequency: 0, // 调用接口时调用消耗条数
    username: '',
    img: '',
    roles: 'admin',
    jurisdiction: [], // 权限
    token: getToken(),
    accountInfo: {}, // 用户账号信息
    staffInfo: { accountType: {} }, // 员工账号信息
    myCredit: 0, // 用户积分
    userAuthencation: {},
    authencaticationStatus: { packageArray: [] },
    isCollapse: false, // 侧边栏 显示隐藏
    helpDocUrl: null, // 帮助文档URL
    helpDocName: '',
    hasCrmEquity: false,
    total: 0, // 总条数
    usedTotal: 0, // 已使用数量
    surplus: 0, // 剩余条数
    closeDate: '--', // 到期时间
    robotHide: false,
    seatsInfo: '', // 座席信息
    callUniqueId: null, // 拨打成功后返回的data
    webSocketMsg: '', // 建立webSocket 服务端返回的信息
    unlockList: [], // 解锁列表数据
    unlockCheckAll: false,
    unlockCheckOne: false,
    deepTaskList: [], //  深度挖掘任务
    landingPageFlag:false,//商机订阅落地页是否存在
    clickCompanyArr:[], //点击过的企业
    erpUserName:'',//erp用户登录
  },
  mutations: {
    SET_WEBSOCKETMSG: (state, value) => {
      state.webSocketMsg = value ? JSON.parse(value) : ''
      // if (state.webSocketMsg && state.webSocketMsg.status === 2) {
      //   state.clickCall = false
      // }
    },
    SET_CALLUNIQUEID: (state, value) => {
      state.callUniqueId = value
    },
    SET_SEATSINFO: (state, value) => {
      state.seatsInfo = value
    },
    SET_DEEP_TASK_LIST: (state, list) => {
      state.deepTaskList = list
    },
    SET_HELP_DOC_URL: (state, url) => {
      state.helpDocUrl = url
    },
    SET_HELP_DOC_NAME: (state, name) => {
      state.helpDocName = name
    },
    SET_CLOSEDATE: (state, closeDate) => {
      state.closeDate = closeDate
    },
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_SURPLUS: (state, surplus) => {
      state.surplus = surplus
    },
    SET_USEDTOTAL: (state, usedTotal) => {
      state.usedTotal = usedTotal
    },
    SET_FREQUENCY: (state, frequency) => {
      state.frequency = frequency
    },

    set_isCollapse: (state, isCollapse) => {
      state.isCollapse = isCollapse
    },
    // 修改用户名
    set_username: (state, username) => {
      state.username = username
    },

    // 修改用户头像
    set_img: (state, img) => {
      state.img = img
    },

    // 修改用户较色
    set_roles: (state, roles) => {
      state.roles = roles
    },

    // 修改用户权限
    set_jurisdiction: (state, jurisdiction) => {
      state.jurisdiction = jurisdiction
    },
    // 设置用户账号信息
    SETACCOUNTINFO (state, value) {
      state.accountInfo = value
    },
    // 设置用户积分
    SETMYCREDIT (state, value) {
      state.myCredit = value
    },
    // 设置员工信息
    SETSTAFFiNFO (state, value) {
      state.staffInfo = value
    },
    // 设置员工认证信息概况
    SETUSERAUTHENTICATION (state, value) {
      state.userAuthencation = value
    },
    // 设置用户认证状态
    SETSTAFFAUTHENTICATIONSTATUS (state, value) {
      state.authencaticationStatus = value
    },
    // 臻口碑
    SETTASK (state, value) {
      state.task = value
    },
    SETTEL (state, value) {
      state.tel = value
    },
    SET_HAS_CRM_EQUITY (state, flag) {
      state.hasCrmEquity = flag
    },
    SET_ROBOT_HIDE (state, flag) {
      state.robotHide = flag
    },
    // 解锁列表
    SET_UNLOCK_LIST (state, val) {
      // 筛选 选中的
      if (state.unlockCheckAll) {
        let combinedArray = state.unlockList.concat(val);
        let uniqueArray = Array.from(new Set(combinedArray.map(item => item.infoId))).map(infoId => {
          return combinedArray.find(item => item.infoId === infoId);
        });
        state.unlockList = uniqueArray
      } else {
        state.unlockList = state.unlockList.filter(f=>!val.map(r=>r.infoId).includes(f.infoId))
      }
    },
    SET_UNLOCK_LIST_NEW (state, val) {
      state.unlockList = val
    },
    SET_UNLOCK_ONE_LIST (state, val) {
      if (state.unlockCheckOne) {
        state.unlockList = state.unlockList.concat(val)
      } else {
        state.unlockList = state.unlockList.filter(item => item.checked)
      }
    },
    // 全选中状态
    SET_UNLOCK_CheckAll (state, val) {
      state.unlockCheckAll = val
    },
    // 单选状态
    SET_UNLOCK_CheckOne (state, val) {
      state.unlockCheckOne = val
    },

    // 商机订阅落地页
    SET_LANDING_PAGE (state, val) {
      state.landingPageFlag = val
    },

    // 点击过的企业
   CLICK_COMPANY_ARR(state, val){
       state.clickCompanyArr = val
    },

    set_ERPUSERNAME: (state, val) => {
      state.erpUserName = val
    },
    
  },
  getters: {
    deepingTaskCount (state) {
      return state.deepTaskList.filter(v => v.status == 1).length
    }
  },
  actions: {
    // callOut ({ commit }, state) {
    //   // 呼叫来源 1:线索 2：联系人 3：客户 4：商机
    //   return new Promise((resolve, reject) => {
    //     callOut({ ...state }).then(res => {
    //       if (res.code === '0') {
    //         commit('SET_CALLUNIQUEID', { id: res.data, sourceId: state.customId })
    //       } else if (res.code === '6000') {
    //         Message({
    //           type: 'warning',
    //           message: res.msg
    //         })
    //       }
    //       resolve({ code: res.code })
    //     })
    //   })
    // },
    queryUserCallClient ({ commit }, state) {
      return new Promise((resolve, reject) => {
        const params = state || {}
        queryUserCallClient(params).then(res => {
          if (res.code === '0') {
            commit('SET_SEATSINFO', res.data)
          }
          resolve(res)
        }).catch(err => { reject(err) })
      })
    },
    async reqHelpDocUrl ({ commit, state }) {
      const res = await helpDocUrl({ id: 22 })
      if (res.code == '200') {
        commit('SET_HELP_DOC_URL', res.data.producturl)
        commit('SET_HELP_DOC_NAME', res.data.productname)
      }
    },
    async hasCrmEquity ({ commit, state }) {
      const res = await hasCrmEquity({})
      if (res.code == '200') {
        commit('SET_HAS_CRM_EQUITY', res.data)
      }
    },
    REQ_DEEP_TASK_LIST ({ commit, state }) {
      interval && clearInterval(interval)
      interval = setIntervalImmediately(() => {
        delveList({}).then(({ code, data = [], message }) => {
          if (code == 200) {
            commit('SET_DEEP_TASK_LIST', data)
            if (!data.some(v => v.status == 1)) {
              interval && clearInterval(interval)
            }
          }
        }).catch(() => { })
      }, 5000)
    },
    PERMISSION_CONFIRM ({ commit, state }) {
      commit('SET_ROBOT_HIDE', true)
      Vue.prototype.$confirm('您的剩余条数不足，无法进行该操作，请联系客服购买', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnPressEscape: true,
        customClass: 'top-level-confirm',
        type: 'warning'
      }).then(() => {
        // window.location.href = process.env.VUE_APP_OW_DOMAIN + 'item/235.html'
        sessionStorage.setItem('initMbox', 0)
      }).catch(() => {
        commit('SET_ROBOT_HIDE', false)
      })
    }
  }
}

export default new Vuex.Store(
  {
    modules: {
      user,
      stepStore,
      lastdrawer,
      tokenList,
      buildPlatformStepStore,
      keepAliveStore,
      industryChainStore,
      advancedSearch,
      asyncRoute,
      someInterest
    },
    state: {
      popularizeFirstStatus: false, // 做推广是否是第一次登陆
      authentication_url: process.env.VUE_APP_7_OPEN + 'userCenter/authentication/fastAuthentication', // 实名认证
      completeInformationURL: process.env.VUE_APP_7_OPEN + 'userCenter/completeInformation', // 完善推广资料
      // purchase_site_url: process.env.VUE_APP_7_OPEN + 'fee/buyKey/tcloud', //购买建站
      // purchase_site_url: process.env.VUE_APP_7_OPEN + 'fee/buyKey/ns', //购买建站
      purchase_site_url: process.env.VUE_APP_OW_DOMAIN + 'list.html', // 购买建站
      domain_list: process.env.VUE_APP_7_OPEN + 'domainManage/domainList', // 域名管理
      kqdpDomainURLPre: 'https://bbc.ttczx.mytcloud.com/index.php?app=shop&m=index&a=shop_sso&token=', // 口乞店铺的测试域名
      kqdpDomainURL: 'https://bbc.ttczx.com/index.php?app=shop&m=index&a=shop_sso&token=', // 口乞店铺的正式域名
      language: 'zh',
      menubarRouters: { children: [] },
      PictureSelector: {
        showPicCon: false, // 图片选择容器
        imgUrls: null, // 图片选择的图片url(回调函数的中转),
        imgSize: 2097152, // 图片的大小限制,默认2mb
        multiple: false // 是否允许多张上传
      },
      waterMark: { show: false },
      filter: {
        show: false,
        arr: [] // 过滤词的集合
      },
      // 图片预览
      preview: { show: false, src: '' },
      headerParams: {
        'X-Account': process.env.VUE_APP_X_Account
      },
      smart_shop_tab: 'fifth',
      isCiBaUser: false // false: 普通用户 true： 云引擎用户
    },
    mutations: {
      SETAUTHURL: (state, url) => {
        // 切换实名认证URL
        state.authentication_url = url
      },
      SWITCHLANGUAGE: (state, val) => {
        // 切换语言
        state.language = val
      },
      SWITCHMENUBAR: (state, val) => {
        // 切换内容导航
        state.menubarRouters = val
      },
      smart_shop_tab_switch: (state, val) => {
        // 智能店铺Tab页面切换
        state.smart_shop_tab = val
      },
      set_smart_shop_user_type: (state, val) => {
        // 设置智能店铺的用户类型
        state.isCiBaUser = val
      }

    },
    actions: {}
  })
